// removed by extract-text-webpack-plugin
module.exports = {"root":"_1TwYW","isSelected":"_abhGb","descr":"_3aNYj","icon":"_2HMiL"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/ProductFeatures/components/CollapseItem/CollapseItem.scss
// module id = 1357
// module chunks = 3